import { EditorProps } from '@monaco-editor/react';

export const customLanguageName = 'kobai-custom';

export const editorOptions: EditorProps = {
  options: {
    lineNumbers: 'off',
    minimap: {
      enabled: false,
    },
    scrollbar: {
      vertical: 'hidden',
      horizontal: 'hidden',
    },
    lineDecorationsWidth: 0,
    lineNumbersMinChars: 0,
    renderLineHighlight: 'none',
    automaticLayout: true,
    fixedOverflowWidgets: true,
    quickSuggestions: true,
    wordWrap: 'on',
    lineHeight: 18,
    suggest: {
      showInlineDetails: true,
    },
  },
};

export const SUB_QUERY_NAME_DELIMITER = '______';
export const SUB_QUERY_URI_DELIMITER = '@@@';
export const OUTPUT_NAME_DELIM = '@';
export const VARIABLE_NAME_DELIM = '#';
